(() => {
  const MOBILE_QUERY = '(max-width: 1023px)';

  const safePlay = (video) => {
    if (!video) return;

    video.muted = true;
    video.playsInline = true;

    const playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  };

  const initLuxuryVideo = (root) => {
    if (!root || root.dataset.loviisaVideoInitialized === 'true') return;

    const panel = root.querySelector('[data-loviisa-video-panel]');
    const video = panel?.querySelector('video');
    const closeButton = root.querySelector('[data-loviisa-video-close]');
    const reopenButton = root.querySelector('[data-loviisa-video-reopen]');

    if (!panel || !video || !closeButton || !reopenButton) return;

    root.dataset.loviisaVideoInitialized = 'true';

    video.muted = true;
    video.playsInline = true;

    safePlay(video);

    closeButton.addEventListener('click', () => {
      video.pause();

      if (window.matchMedia(MOBILE_QUERY).matches) {
        root.classList.add('is-minimized');
        root.classList.remove('is-collapsed');
      } else {
        root.classList.add('is-collapsed');
        root.classList.remove('is-minimized');
      }

      reopenButton.hidden = false;
    });

    reopenButton.addEventListener('click', () => {
      root.classList.remove('is-collapsed', 'is-minimized');

      reopenButton.hidden = true;

      window.requestAnimationFrame(() => {
        safePlay(video);
      });
    });
  };

  const initAll = (scope = document) => {
    scope
      .querySelectorAll('[data-loviisa-luxury-media]')
      .forEach(initLuxuryVideo);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();